var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqUnlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1008 16.8203C29.591 16.8203 29.9883 16.4229 29.9883 15.9329V2.89818C29.9883 2.40804 29.5909 2.01071 29.1008 2.01071H23.754V16.8203H29.1008Z",
    fill: "#121933",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0105667 11.9187C0.0105667 13.0453 0.615902 14.0332 1.51836 14.5742C1.1726 15.0735 0.969809 15.6792 0.969809 16.3312C0.969809 18.037 2.35766 19.4249 4.0635 19.4249H10.5943C10.3941 20.3319 10.1204 21.693 9.92974 23.1178C9.43369 26.8257 9.77271 28.882 10.9966 29.5892C11.7596 30.03 12.5822 30.1194 13.313 29.8412C13.8776 29.6262 14.64 29.0975 15.0745 27.7999L16.7909 23.3057C17.6611 21.1567 20.3259 18.9005 21.9785 17.653L21.9785 1.61715C18.9156 0.543945 15.7194 -4.00543e-05 12.4587 -4.00543e-05L5.34267 -4.00543e-05C3.63683 -4.00543e-05 2.24897 1.38781 2.24897 3.09366C2.24897 3.69102 2.41919 4.24942 2.71362 4.7228C1.68231 5.22506 0.969923 6.28409 0.969923 7.50618C0.969923 8.15821 1.17272 8.76378 1.51848 9.26312C0.6159 9.80417 0.0105667 10.7921 0.0105667 11.9187Z",
    fill: "#121933",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "matrix(-1 0 0 -1 30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqUnlike);
export default __webpack_public_path__ + "static/media/faq_unlike.810a950b65b6ce7f306d338767e508d2.svg";
export { ForwardRef as ReactComponent };